const TYPE = {
  SOCKET_OPEN: 'SOCKET_OPEN',
  SOCKET_ERROR: 'SOCKET_ERROR',
  SOCKET_CLOSE: 'SOCKET_CLOSE',
  SOCKET_RECONNECT: 'SOCKET_RECONNECT',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  READY_SUCCESS: 'READY_SUCCESS',
  READY_FAIL: 'READY_FAIL',
  CHAT: 'CHAT',
  SEND_FAIL: 'SEND_FAIL',
  GET_HISTORY_SUCCESS: 'GET_HISTORY_SUCCESS',
  GET_HISTORY_FAIL: 'GET_HISTORY_FAIL',
  GET_TALK_LIST: 'GET_TALK_LIST',
  GET_TAKE_OVER_LIST: 'GET_TAKE_OVER_LIST',
  GET_TAKE_OVER_USER: 'GET_TAKE_OVER_USER',
  GET_TAKE_OVER_SUCCESS: 'GET_TAKE_OVER_SUCCESS',
  GET_TAKE_OVER_FAIL: 'GET_TAKE_OVER_FAIL',
  GET_CUSTOMER_SERVICE_SUCCESS: 'GET_CUSTOMER_SERVICE_SUCCESS',
  GET_CUSTOMER_SERVICE_FAIL: 'GET_CUSTOMER_SERVICE_FAIL',
  READ_MESSAGE_SUCCESS: 'READ_MESSAGE_SUCCESS',
  READ_MESSAGE_FAIL: 'READ_MESSAGE_FAIL',
  UNREAD_NUM: 'UNREAD_NUM',
  RECALL_MESSAGE_SUCCESS: 'RECALL_MESSAGE_SUCCESS',
  RECALL_MESSAGE_FAIL: 'RECALL_MESSAGE_FAIL',
  SET_TOP_SUCCESS: 'SET_TOP_SUCCESS',
  SET_TOP_FAIL: 'SET_TOP_FAIL',
  ADD_TALK_SUCCESS: 'ADD_TALK_SUCCESS',
  ADD_TALK_FAIL: 'ADD_TALK_FAIL',
  TYPING_SUCCESS: 'TYPING_SUCCESS',
  TYPING_FAIL: 'TYPING_FAIL'
}

export default TYPE
